export default __webpack_public_path__ + "images/90d574ae931dc708d02127bce9e587d4-islam.jpg";